import React from 'react';
import { Table as TanstackTable } from '@tanstack/react-table';
import { Z_INDEX } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { TableData, getTableFilterMeta } from './types';
import { STICKY_TABLE_APPLIED_FILTERS_ROW_TOP, STICKY_TABLE_HEADER_HEIGHT } from './constants';

interface Props<T extends TableData> {
	table: TanstackTable<T>;
	enableStickyHeader?: boolean;
	isVisible?: boolean;
	children: React.ReactNode;
}

export const MantineTableFilterSubrow = <T extends TableData>({
	table,
	enableStickyHeader,
	isVisible = true,
	children,
}: Props<T>) => {
	if (!isVisible || !children) {
		return null;
	}

	const stickyTop = getTableFilterMeta(table).showColumnFilters
		? STICKY_TABLE_APPLIED_FILTERS_ROW_TOP
		: STICKY_TABLE_HEADER_HEIGHT;

	return (
		<div
			style={{
				gridColumn: '1 / -1',
				padding: '8px',
				borderBottom: `1px solid ${defaultTheme.v3.colors.gray[4]}`,
				...(enableStickyHeader && {
					position: 'sticky',
					top: stickyTop,
					backgroundColor: 'white',
					zIndex: Z_INDEX.STICKY_HEADER,
				}),
			}}
		>
			{children}
		</div>
	);
};
